﻿// css:
import './components/styles/styles.scss';
import './components/designerOverlayModal/designerOverlayModal.scss';
import './components/transforToCartOverlayModal/transforToCartOverlayModal.scss';
import './components/confirmationModal/confirmationModal.scss';

// scripts:
import './components/logoCreatorMiddleWare/logoCreatorMiddleware';

import { createRoot } from 'react-dom/client';
import { PersonalizeOverlayWrapper } from './components/personalizeOverlay/personalizeOverlayWrapper';
import { IContext } from './components/types';
const context: IContext = window.__PP_LC_CONTEXT__;
const overlayContainer = document.createElement('lc-personalizeOverlay');
document.body.appendChild(overlayContainer);
const root = createRoot(overlayContainer);
root.render(<PersonalizeOverlayWrapper
    localization={context.localization}
    ssoId={context.ssoId}
    isEsApp={context.isEsApp}
    isFullyRegistered={context.fullyRegistered}
    hasCustomerLogo={context.hasCustomerLogo}
/>);
